module.exports = __webpack_public_path__ + "media/assets/images/authors/marco_galvagni-518a83cc0957ae7c65157c755a8c71b0.jpg";